var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Star_Filled_Copy",
    "data-name": "icons/Star/Filled Copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.333,
    height: 9.333,
    viewBox: "0 0 9.333 9.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.138.2,4.667,3.724,8.2.2a.667.667,0,1,1,.943.943L5.609,4.667,9.138,8.2a.667.667,0,0,1-.943.943L4.667,5.609,1.138,9.138A.667.667,0,0,1,.2,8.2L3.724,4.667.2,1.138A.667.667,0,0,1,1.138.2Z",
    transform: "translate(0 0)",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCross);
export default __webpack_public_path__ + "static/media/filterCross.fb991a3fb7ac2808a98e9dbfea1ca048.svg";
export { ForwardRef as ReactComponent };